/**
 * 单例模式的注解
 * Created by slipkinem on 2018/7/25 at 下午1:45.
 */
export function singleton<T extends { new (...args: any[]): {} }>(
  construtor: T
) {
  return class Singleton extends construtor {
    constructor(...args: any[]) {
      super(args);
      if (Singleton._singleton) {
        return Singleton._singleton;
      }

      Singleton._singleton = this;
    }

    private static _singleton?: Singleton = undefined;
  };
}
